import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';

import './theme';

function applyConfig(config: ConfigType) {
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.wildcardcorpTheme = 'loaded';
  }
  installSettings(config);

  return config;
}

export default applyConfig;